export default "__VITE_ASSET__BPn$QIpN__"